import { type CurrentUser } from '../../resources/User/types';
import { type HttpClient } from '../useHttpClient';

export const fetchCurrentUser = (httpClient: HttpClient) => async () => {
  const response = await httpClient.api('/users/current');

  return response.json as CurrentUser;
};
